/* istanbul ignore file */
import React from 'react';
import { useHistory } from 'react-router-dom';

function EmptyNotificationGroupsMessage() {
  const history = useHistory();
  return (
    <div className="card">
      <div className="card-body text-left">
        <h4>Managing alert notifications is simple. Here&#39;s what you need to know:</h4>
        <ul>
          <li>Group together any recipients that need the same set(s) of alert notifications.</li>
          <li>1 notification group can be associated with multiple alerts (and vice-versa).</li>
          <li>
            Separate notification groups are needed in order to...
            <ul>
              <li>apply different quiet time schedules for recipients.</li>
              <li>send reminders to recipients at different intervals / a max # of times.</li>
              <li>wait different amounts of time before notifying recipients.</li>
              <li>use different notification templates to notify recipients.</li>
            </ul>
          </li>
          <li>
            Learn more:
            {' '}
            <a target="_blank" rel="noopener noreferrer" href="https://avtech.com/articles/11431/">
              How To Create Notification Groups In Room Alert Account
            </a>
            .
          </li>
        </ul>
        <div className="my-3 row">
          <div className="col">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push('/s/actions/notification-groups/new')}
            >
              Create notification group
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyNotificationGroupsMessage;
